import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantRoutes = [

  // 登录页
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // 密码重置
  {
    path: '/backword',
    component: () => import('@/views/backword/index'),
    hidden: true
  },
  // 404页面
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    redirect: '/student'
  },
  // 学生模块相关 路由
  {
    path: '/student',
    component: Layout,
    redirect: '/student/stuitem',
    name: 'Student',
    meta: { title: '学生管理', icon: 'el-icon-user' },
    children: [
      {
        path: 'stuitem',
        name: 'Stuitem',
        component: () => import('@/views/student/stuitem/index'),
        meta: { title: '学生信息管理' }
      },
      {
        path: 'graduateitem',
        name: 'Graduateitem',
        component: () => import('@/views/student/graduateitem/index'),
        meta: { title: '毕业生信息管理' }
      },
      {
        path: 'stupoints',
        name: 'Stupoints',
        component: () => import('@/views/student/stupoints/index'),
        meta: { title: '学生加分管理' }
      },
      {
        path: 'down',
        name: 'Town',
        component: () => import('@/views/student/stuitem/down/index.vue'),
        hidden: true
      }
    ]
  },

  // 教师模块相关 路由
  {
    path: '/teacher',
    component: Layout,
    redirect: '/teacher/teaitem',
    name: 'Teacher',
    meta: { title: '教师管理', icon: 'el-icon-s-custom' },
    children: [
      {
        path: 'teaitem',
        name: 'Teaitem',
        component: () => import('@/views/teacher/teaitem/index.vue'),
        meta: { title: '教师信息管理' }
      }
      // {
      //   path: 'teaedu',
      //   name: 'Teaedu',
      //   meta: { title: '教师教务统计' },
      //   hidden: true,
      //   component: () => import('@/views/teacher/teaedu/index'),
      //   children: [
      //     {
      //       path: 'classroom',
      //       name: 'Classroom',
      //       component: () => import('@/views/teacher/teaedu/classroom'),
      //       meta: { title: '课堂使用统计' },
      //       children: [
      //         {
      //           path: 'classroomdu',
      //           component: () => import('@/views/teacher/teaedu/classroom/classroomdu'),
      //           name: 'Classroomdu',
      //           meta: { title: '课堂使用统计' }
      //         }
      //       ]
      //     },
      //     {
      //       path: 'workroom',
      //       name: 'Workroom',
      //       component: () => import('@/views/teacher/teaedu/workroom'),
      //       meta: { title: '作业使用统计' },
      //       children: [
      //         {
      //           path: 'workroomdu',
      //           component: () => import('@/views/teacher/teaedu/workroom/workroomdu'),
      //           name: 'Workroomdu',
      //           meta: { title: '作业使用统计' }
      //         }
      //       ]
      //     },
      //     {
      //       path: 'testroom',
      //       name: 'Testroom',
      //       component: () => import('@/views/teacher/teaedu/testroom'),
      //       meta: { title: '考试使用统计' },
      //       children: [
      //         {
      //           path: 'testroomdu',
      //           component: () => import('@/views/teacher/teaedu/testroom/testroomdu'),
      //           name: 'Testroomdu',
      //           meta: { title: '考试使用统计' }
      //         }
      //       ]
      //     },
      //     {
      //       path: 'schoolroom',
      //       name: 'Schoolroom',
      //       component: () => import('@/views/teacher/teaedu/schoolroom'),
      //       meta: { title: '校本资源统计' },
      //       children: [
      //         {
      //           path: 'schoolroomdu',
      //           component: () => import('@/views/teacher/teaedu/schoolroom/schoolroomdu'),
      //           name: 'Schoolroomdu',
      //           meta: { title: '校本资源统计' }
      //         }
      //       ]
      //     }
      //   ]
      // }
    ]
  },

  // 学情分析
  // {
  //   path: '/learn',
  //   component: Layout,
  //   children: [
  //     // 如果children项超过两项显示就会展开菜单的效果
  //     {
  //       path: '',
  //       name: 'Learn',
  //       component: () => import('@/views/learn/index.vue'),
  //       // meta中的title控制的是左侧链接的文本, icon控制的图标
  //       meta: { title: '学情分析', icon: 'el-icon-s-promotion' }
  //     }
  //   ]
  // },

  // App管理
  // {
  //   path: '/app',
  //   component: Layout,
  //   redirect: '/app/banner',
  //   name: 'App',
  //   meta: { title: 'APP管理', icon: 'el-icon-menu' },
  //   children: [
  //     {
  //       path: 'banner',
  //       name: 'Banner',
  //       component: () => import('@/views/appadmin/banneradmin/index.vue'),
  //       meta: { title: 'banner管理' }
  //     },
  //     {
  //       path: 'banner1',
  //       name: 'Banner1'
  //     }

  //   ]
  // },

  // 资源管理
  {
    path: '/rescour',
    component: Layout,
    redirect: '/rescour/inschool',
    name: 'Rescour',
    meta: { title: '资源管理', icon: 'el-icon-coin' },
    children: [
      {
        path: 'inschool',
        name: 'Inschool',
        component: () => import('@/views/rescour/inschool/index.vue'),
        meta: { title: '本校资源' }
      }
      // {
      //   path: 'errescour',
      //   name: 'Errescour',
      //   component: () => import('@/views/rescour/errescour/index.vue'),
      //   meta: { title: '报错资源' }
      // }
    ]
  },

  // 文件详情页面
  {
    path: '/filedetail',
    component: () => import('@/views/rescour/filedetail/file-detail.vue')
  },
  // 素材详情
  {
    path: '/pptdetail',
    component: () => import('@/views/rescour/pptdetail/ppt-detail.vue')
  },
  // 试题详情
  {
    path: '/topicdetail',
    component: () => import('@/views/rescour/topicdetail/topic-detail.vue')
  },
  // 资讯管理
  // {
  //   path: '/inform',
  //   component: Layout,
  //   children: [
  //     // 如果children项超过两项显示就会展开菜单的效果
  //     {
  //       path: '',
  //       name: 'Inform',
  //       component: () => import('@/views/information/index.vue'),
  //       // meta中的title控制的是左侧链接的文本, icon控制的图标
  //       meta: { title: '资讯管理', icon: 'el-icon-notebook-2' }
  //     },
  //     {
  //       path: 'publish',
  //       name: 'Publish',
  //       component: () => import('@/views/information/publish/index.vue'),
  //       hidden: true
  //     }
  //   ]
  // },

  // 教材设置
  {
    path: '/settextbook',
    component: Layout,
    children: [
      // 如果children项超过两项显示就会展开菜单的效果
      {
        path: '',
        name: 'Settextbook',
        component: () => import('@/views/settextbook/index.vue'),
        // meta中的title控制的是左侧链接的文本, icon控制的图标
        meta: { title: '教材设置', icon: 'el-icon-document-copy' }
      }
    ]
  },

  // 批处理查询
  {
    path: '/dealcheck',
    component: Layout,
    children: [
      // 如果children项超过两项显示就会展开菜单的效果
      {
        path: '',
        name: 'Dealcheck',
        component: () => import('@/views/dealcheck/index.vue'),
        // meta中的title控制的是左侧链接的文本, icon控制的图标
        meta: { title: '批处理查询', icon: 'el-icon-reading' }
      }
    ]
  },

  // 修改密码 姓名
  {
    path: '/updateuser',
    redirect: '/updateuser/update_password',
    component: Layout,
    name: 'Updateuser',
    children: [
      {
        path: 'update_password',
        name: 'updatePassword',
        component: () => import('@/views/updateuser/update_password/index'),
        hidden: true
      },
      {
        path: 'update_name',
        name: 'updateName',
        component: () => import('@/views/updateuser/update_name/index'),
        hidden: true
      }
    ]
  },
  // {
  //   path: '/form',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'Form',
  //       component: () => import('@/views/form/index'),
  //       meta: { title: 'Form', icon: 'form' }
  //     }
  //   ]
  // },

  // {
  //   path: '/nested',
  //   component: Layout,
  //   redirect: '/nested/menu1',
  //   name: 'Nested',
  //   meta: {
  //     title: 'Nested',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'menu1',
  //       component: () => import('@/views/nested/menu1/index'), // Parent router-view
  //       name: 'Menu1',
  //       meta: { title: 'Menu1' },
  //       children: [
  //         {
  //           path: 'menu1-2',
  //           component: () => import('@/views/nested/menu1/menu1-2'),
  //           name: 'Menu1-2',
  //           meta: { title: 'Menu1-2' },
  //           children: [
  //             {
  //               path: 'menu1-2-1',
  //               component: () => import('@/views/nested/menu1/menu1-2/menu1-2-1'),
  //               name: 'Menu1-2-1',
  //               meta: { title: 'Menu1-2-1' }
  //             }
  //           ]
  //         }
  //       ]
  //     }
  //   ]
  // },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  // 重置路由的方法
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
